import Reveal from '@/components/base/Reveal';

export default function CtaSection() {
  return (
    <section className="relative py-28 px-6 md:px-12 lg:px-16 bg-[#080808]">
      <div className="max-w-4xl mx-auto text-center">
        <Reveal variant="fadeUp" duration={800}>
          <p className="text-xs tracking-[0.3em] text-white/60 uppercase mb-6">Want to support our mission?</p>
        </Reveal>

        <Reveal variant="fadeUp" delay={120} duration={950}>
          <h2
            className="text-4xl md:text-5xl lg:text-6xl font-normal font-['Instrument_Serif'] text-white mb-8"
            style={{ letterSpacing: '-0.02em' }}
          >
            Support our mission.<br />Their next chapter starts here.
          </h2>
        </Reveal>

        <Reveal variant="scaleUp" delay={280} duration={800}>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="https://hcb.hackclub.com/donations/start/sapphire">
              <button className="bg-white text-black px-10 py-4 rounded-lg font-medium hover:bg-gray-100 transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm">
                Donate
              </button>
            </a>
            {/* <button className="liquid-glass border border-white/20 text-white px-10 py-4 rounded-lg font-medium hover:bg-white hover:text-black transition-all duration-200 whitespace-nowrap cursor-pointer text-sm">
              Reach Out 
            </button> */}
            <a href="mailto:hello@sapphiremedia.group">
              <button className="liquid-glass border border-white/20 text-white px-10 py-4 rounded-lg text-xs sm:text-sm hover:bg-white hover:text-black transition-all duration-200 whitespace-nowrap cursor-pointer text-sm inline-flex items-center gap-1 sm:gap-1.5">
                Reach out
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.75} stroke="currentColor" className="size-3.5 sm:size-4">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
                </svg>
              </button>
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
